<template>
    <div class="tw-flex tw-items-center tw-cursor-pointer tw-relative">
        <div id="logoutMenuButton" ref="button" @click="isDropdownOpen = ! isDropdownOpen" class="tw-flex">
            <div class="elipse tw-flex-shrink-0 tw-mr-2 tw-ml-4 tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-border">
                <img :src="imageRoute" alt="" class="tw-rounded-full">
            </div>
            <div class="tw-flex-shrink-0 sm:tw-flex sm:tw-items-center">
                <p class="tw-text-white md:tw-text-black sm:text-md font-semibold">{{ user.first_name }} {{ user.last_name }}</p>
                <p class="tw-text-brown-grey  tw-text-xs sm:tw-hidden">{{ user.email }}</p>
            </div>
        </div>

        <div id="topbar-user-dropdown" 
             class="tw-absolute tw-bg-white tw-border tw-border-slate-grey tw-flex tw-flex-col tw-rounded tw-mt-4" 
             style="min-width: 220px; top: 100%; right: 0; z-index: 999;"
             v-show="isDropdownOpen"
             v-closable="{
                exclude: ['#logoutMenuButton'],
                handler: 'onClose'
            }"
        >
            <div class="tw-whitespace-nowrap tw-px-4 tw-pt-3">
                <div class="tw-text-black">
                    {{ user.first_name }} {{ user.last_name }}
                </div>
                <div class="tw-text-brown-grey tw-text-xs">
                    {{ user.email }}
                </div>
            </div>

            <a :href="accountSettingsRoute" class="tw-whitespace-nowrap tw-text-slate-grey hover:tw-text-brand-primary-foreground hover:tw-bg-brand-primary focus:tw-bg-brand-primary active:tw-bg-brand-primary focus:tw-text-white active:tw-text-white tw-px-4 tw-py-3 tw-no-underline hover:tw-no-underline active:tw-no-underline focus:tw-no-underline tw-flex tw-items-center">
                <i class="fa-cog fas fa-fw tw-text-sm"></i>
                <span class="tw-ml-3">
                    Accounteinstellungen
                </span>
            </a>

            <a :href="logoutRoute" class="tw-whitespace-nowrap tw-text-slate-grey hover:tw-text-brand-primary-foreground hover:tw-bg-brand-primary focus:tw-bg-brand-primary active:tw-bg-brand-primary focus:tw-text-white active:tw-text-white tw-px-4 tw-py-3 tw-no-underline hover:tw-no-underline active:tw-no-underline focus:tw-no-underline tw-flex tw-items-center">
                <i class="fa-power-off fas fa-fw tw-text-sm"></i>
                <span class="tw-ml-3">
                    Abmelden
                </span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                required: true,
                type: Object,
            },
            imageRoute: {
                required: true,
                type: String,
            },
            logoutRoute: {
                required: true,
                type: String,
            },
            accountSettingsRoute: {
                required: true,
                type: String,
            },
        },

        data() {
            return {
                isDropdownOpen: false,
            }
        },

        methods: {
            onClose() {
                this.isDropdownOpen = false;
            },
        },

        mounted() {
            
        }
    }
</script>
